<div>
	@if (type() === Datepickers.INLINE) {
		<div class="flex flex-col p-5 bg-white rounded border border-secondary-300 w-full">
			<ui-datepicker-base
				[currentlyDisplayedMonth]="currentlyDisplayedMonth()"
				[disabled]="disabled()"
				[excludedDates]="excludedDates()"
				[selectedDate]="value()"
				(navDateChange)="onNavigationChange($event)"
				(calendarWeekClicked)="calendarWeekClicked.emit($event)"
				(dateSelectionChange)="onDateSelectionChange($event)"
				[minDate]="minDate()"
				[maxDate]="maxDate()"
				[syncedDate]="syncedDate()"
			></ui-datepicker-base>
		</div>
	} @else {
		<ui-datepicker-input
			[placeholder]="placeholder() || (userFormat().date | dateFormatFormatter)"
			[(value)]="value"
			[disabled]="disabled()"
			(valueChange)="onValueChange($event)"
			[minDate]="minDate()"
			[maxDate]="maxDate()"
			[showWhenValid]="showWhenValid()"
			[syncedDate]="syncedDate()"
			[currentlyDisplayedMonth]="currentlyDisplayedMonth()"
			(calendarWeekClicked)="calendarWeekClicked.emit($event)"
			[inputId]="inputId()"
			[invalid]="invalid()"
			[userFormat]="dateFormat()"
			(calendarOpened)="onCalendarOpened()"
			[excludedDates]="excludedDates()"
			[useContainerWidth]="useContainerWidth()"
			[containerSelector]="containerSelector()"
			#datepickerInputComponent
		>
		</ui-datepicker-input>
	}
</div>
